import type React from "react";
import styles from "./index.module.scss";

interface CustomRadioProps {
  label: string;
  name: string;
  value: string;
  checked?: boolean;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

export const CustomRadio: React.FC<CustomRadioProps> = ({
  label,
  name,
  value,
  checked = false,
  onChange,
  disabled = false,
}) => {
  return (
    <div className={styles["radio-wrapper"]}>
      <label className={styles["radio-label"]}>
        <input
          type="radio"
          className={styles["custom-radio"]}
          name={name}
          value={value}
          checked={checked}
          onChange={() => onChange?.(value)}
          disabled={disabled}
        />
        <span className={styles["custom-radio-ui"]}></span>
        <span>{label}</span>
      </label>
    </div>
  );
};
